import type { Team } from '$lib/domain/team.interface';

export const team: Team[] = [
    {
        name: 'Oleg Maykher',
        position: 'CEO & Co-founder',
        linked: 'https://www.linkedin.com/in/omaykher/',
        email:'omaykher@exoft.net'
    },
    {
        name: 'Ivan Shikht',
        position: 'Co-founder',
        linked: 'https://www.linkedin.com/in/shikht/',
        email:'ishikht@exoft.net'
    },
    {
        name: 'Taras Yaremkiv',
        position: 'Chief Technology Officer',
        linked: 'https://www.linkedin.com/in/taras-yaremkiv-a44217ab/',
        email:'tiaremkiv@exoft.net'
    },
    {
        name: 'Alex Shepelyuk',
        position: ' Chief Business Development Officer',
        linked: 'https://www.linkedin.com/in/alexshepelyuk/',
        email:'ashepelyuk@exoft.net'
    },
    {
        name: 'Nadiia Hnezdyuk',
        position: 'Chief Financial Officer',
        linked: 'https://www.linkedin.com/in/nadiya-hnezdyuk-74371755/',
        email:'nhnezdyuk@exoft.net'
    },
    {
        name: 'Anna Oleksiuk',
        position: 'Head of Marketing',
        linked: 'https://www.linkedin.com/in/anna-oleksiuk-b44a44141/',
        email:'aoleksiuk@exoft.net'
    },
    {
        name: 'Olena Balahurak',
        position: 'Account Manager',
        linked: 'https://www.linkedin.com/in/olena-balahurak-49a077168/',
        email:'obalahurak@exoft.net'
    },
];
